<template>
  <!-- <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="resetData"
    wrapClassName="act-now-chat-ai-modal"
  > -->
  <div class="act-now-chat-ai-modal-container">
    <div ref="aiChatContainer" class="act-now-chat-ai-modal-container__body">
      <template v-if="isActNowChatLoading">
        <a-skeleton 
          class="act-now-chat-ai-modal-container__body--chat-skeleton"
          active
          :title="null"
          :paragraph="{
            rows: 6,
            width: ['100%', '100%', '100%', '100%', '60%', '50%'],
          }"
        ></a-skeleton>
      </template>
      <div
        v-for="(chatId, index) in actNowChatArrayId"
        :key="'chat-' + chatId"
        class="act-now-chat-ai-modal-container__body--chat-wrapper"
      >
        <div v-if="actNowChat.get(chatId)?.role === 'system'" class="act-now-chat-ai-modal-container__body--chat-wrapper--header">
          <button @click="handleCopy(index)" class="act-now-chat-ai-modal-container__body--chat-wrapper--header--btn">
            <img src="@/assets/icons/copy-icon.png" alt="Copy" />
            {{ copiedKeys[`chat-${index}`] ? "Copied!" : "Copy" }}
          </button>
          <button @click="toggleShareLetterModal(chatId)" class="act-now-chat-ai-modal-container__body--chat-wrapper--header--btn">
            <img src="@/assets/icons/share2.png" alt="Copy" />
            Share
          </button>
        </div>
        <p
          :ref="'chatText' + index"
          v-html="parseMessage(chatId)"
          :class="[
            'act-now-chat-ai-modal-container__body--chat-wrapper--description',
            { 'act-now-chat-ai-modal-container__body--chat-wrapper--reply': actNowChat.get(chatId)?.role == 'user' }
          ]"
        ></p>
        <h1 class="act-now-chat-ai-modal-container__body--chat-wrapper--ai-meesage" v-if="actNowChat.get(chatId)?.role === 'system'">
          Note: AI-generated content — please verify for accuracy.
        </h1>
      </div>
      <h1 class="select-user-card-title">Contacts you selected are shown below</h1>
      <a-row :gutter="[16]">
        <a-col 
          :xs="24" :sm="24" :md="24" :lg="24" :xl="24" 
          v-for="(selectedAuthorities, index) in actNowSelectedAuthorities"
          :key="'authority-' + selectedAuthorities?.id"
        >
          <div
            class="select-user-card"
          >
            <div v-if="selectedAuthorities?.name" class="select-user-card__field">
              <p><span>Name: </span><span class="details">{{ selectedAuthorities?.name }}</span></p>
              <button class="copy-btn" @click="copyToClipboard(selectedAuthorities.name, 'name-' + index)">
                <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                <div v-if="copiedKeys[`name-${index}`]" class="copied"><p>Copied!</p></div>
              </button>
            </div>

            <div v-if="selectedAuthorities?.email || selectedAuthorities?.phone" class="select-user-card__field">
              <p><span>{{ selectedAuthorities?.email ? 'Email:' : 'Phone:'}} </span><span class="details">{{ selectedAuthorities?.email || selectedAuthorities?.phone }}</span></p>
              <button class="copy-btn" @click="copyToClipboard(selectedAuthorities.email || selectedAuthorities?.phone, 'email-' + index)">
                <img src="@/assets/icons/copy-icon.png" alt="Copy" />
                <div v-if="copiedKeys[`email-${index}`]" class="copied"><p>Copied!</p></div>
              </button>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="act-now-chat-ai-modal-container__footer">
      <div class="act-now-chat-ai-modal-container__footer--comment">
        <img
          src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
        />
        <textarea v-model='textPrompt' cols="30" placeholder="How would you like to further tailor this letter."></textarea>
        <div class="buttons">
          <a-button :loading="sendButtonLoader" @click.stop='updateLetter()' class="btn">
            <i class="icon icon-send"></i>
          </a-button>
        </div>
      </div>
    </div>
  </div>
  <ShareContactsModal
   :visible="visibleShareContatsModal"
   @closeModal="toggleShareLetterModal()"
   :chatId="chatId"
   :articleLink="articleLink"
  />
  <!-- </a-modal> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {marked} from 'marked'
import ShareContactsModal from "../ShareContactsModal.vue";
export default {
  props: {
    visible: Boolean,
    articleId:{
      type:String,
      default: () => (''),
      required: true
    },
  },
  components: {
    ShareContactsModal
  },
  data() {
    return {
      copiedKeys: {},
      sendButtonLoader: false,
      textPrompt:'',
      startFetching: false,
      prevScroll: 0,
      currentScroll: 0,
      scrollDown: false,
      visibleShareContatsModal: false,
      chatId: '',
      articleLink: ''
    };
  },
  computed: {
    ...mapGetters({
      actNowSelectedAuthorities: "discover/actNowSelectedAuthorities",
      actNowChat: "discover/actNowChat",
      actNowChatAIResponseLoader: 'discover/actNowChatAIResponseLoader',
      isActNowChatLoading: 'discover/isActNowChatLoading',
      actNowChatPage: 'discover/actNowChatPage',
      actNowChatHasMorePage: 'discover/actNowChatHasMorePage',
      actNowChatArrayId: 'discover/actNowChatArrayId',
      stateActiveTopicTab: 'discover/activeTopicTab',
    }),
  },
  watch:{
    actNowChatArrayId:{
      handler(actNowChatList){
        if (actNowChatList.length > 0){
          this.$nextTick(()=>{
            const containerElement = this.$refs.aiChatContainer
            if (containerElement && (this.prevScroll === 0 || this.scrollDown)){
              containerElement.scrollTo({
                top: containerElement.scrollHeight,
                behavior: 'smooth'
              })
              this.scrollDown = false
            }
          })
        }
      }, immediate:true
    },
    actNowChatPage:{
      handler(chatPage){
        if (chatPage > 1){
          (async()=>{
            await this.fetchActNowChat({articleId: this.articleId})
            const containerElement = this.$refs.aiChatContainer
            if (containerElement)
              containerElement.scrollTop = 400
            this.startFetching = false
          })()
          
        } 
      }, immediate: true
    },
    visible:{
      handler(isVisible){
        if (isVisible){
          this.textPrompt = ''
          this.sendButtonLoader = false
        }
      },immediate:true
    }
  },
  mounted(){
    // this.$nextTick(()=>{
    //   const containerElement = this.$refs.aiChatContainer
    //   if (containerElement){
    //     containerElement.addEventListener('scroll', ()=>{
    //       this.currentScroll = containerElement.scrollTop
    //        const currentScrollY = containerElement.scrollTop;
    //        if (currentScrollY < this.prevScroll && currentScrollY <= 200 && !this.startFetching && this.actNowChatHasMorePage){
    //           this.startFetching = true
    //           this.incrementOrDecrementActNowChatPage({action:'increment'})
    //        }
    //        if (currentScrollY > 0)
    //           this.prevScroll = currentScrollY
    //     })
    //   }
    // })
  },
  methods: {
    ...mapActions({
      refactorOfficialLetter: 'discover/refactorOfficialLetter',
      setActNowChatResponseLoader: 'discover/setActNowChatResponseLoader',
      incrementOrDecrementActNowChatPage: 'discover/incrementOrDecrementActNowChatPage',
      fetchActNowChat: 'discover/fetchActNowChat',
      emptyActNowChat: 'discover/emptyActNowChat'
    }),
    resetData() {
      this.textPrompt = ''
      this.sendButtonLoader = false
      this.setActNowChatResponseLoader(false)
      this.emptyActNowChat()
    },
    copyToClipboard(text, key) {
      if (!text) return;

      const copyText = async () => {
        try {
          await navigator.clipboard.writeText(text);
          this.copiedKeys[key] = true;
          setTimeout(() => {
            this.copiedKeys[key] = false;
          }, 2000);
        } catch (err) {
          // Fallback for unsupported mobile browsers
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.setAttribute("readonly", "");
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();

          try {
            const successful = document.execCommand("copy");
            if (successful) {
              this.copiedKeys[key] = true;
              setTimeout(() => {
                this.copiedKeys[key] = false;
              }, 2000);
            } else {
              alert("Copy failed");
            }
          } catch (err) {
            console.error("Fallback copy failed", err);
            alert("Copy not supported on this device.");
          }

          document.body.removeChild(textarea);
        }
      };

      copyText();
    },
    handleCopy(index) {
      const el = this.$refs["chatText" + index];
      if (el) {
        const text = el.innerText || el.textContent;
        this.copyToClipboard(text, `chat-${index}`);
      }
    },
    parseMessage(chatId){
      if (this.actNowChat.has(chatId)){
        const chatObject = this.actNowChat.get(chatId)
        return marked.parse(chatObject?.letter || chatObject?.content)
      }
    }, 
    async updateLetter(){
      try{
        this.sendButtonLoader = true
        await this.refactorOfficialLetter({articleId:this.articleId, content:this.textPrompt})
        this.setActNowChatResponseLoader(true)
        this.scrollDown = true
      }
      catch(err){
        console.log(err)
      }finally{
        this.sendButtonLoader = false
        this.textPrompt = ''
      }
    },
    toggleShareLetterModal(chatId='') {
      this.visibleShareContatsModal = !this.visibleShareContatsModal
      this.chatId = chatId
      this.articleLink = `${process.env.VUE_APP_REDIRECTION_URL}/discover/article/${this.stateActiveTopicTab.split(" ").join("-")}/${this.articleId}`
    }
  },
};
</script>

<style lang="scss">
.act-now-chat-ai-modal-container {
  &__body {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 32rem);
    padding: 0rem 2.5rem;
    margin-top: 2rem;
    @include respond(phone-large) {
      max-height: calc(100vh - 50rem);
    }
    &--chat-skeleton {
      .ant-skeleton-content {
        .ant-skeleton-paragraph {
          margin: 0;
          li {
            height: 1.8rem;
            margin-bottom: 0.8rem;
          }
        }
      }
    }
    &--chat-wrapper {
      margin-bottom: 1rem;
      &--header {
        background-color: $color-white;
        width: 100%;
        position: sticky;
        top: -0.3rem;
        padding: 0.5rem 0 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1.2rem;
        &--btn {
          display: flex;
          align-items: center;
          background-color: #e7e7e7;
          padding: 0.4rem 0.7rem;
          border: none;
          outline: none;
          font-size: 1.4rem;
          line-height: normal;
          font-family: $font-primary-medium;
          cursor: pointer;
          gap: 0.5rem;
          font-weight: 500;
          color: $color-black;
          img {
            width: 1.5rem;
            height: auto;
          }
          @include respond(phone-large) {
            font-size: 1.8rem;
            padding: 0.8rem 1rem;
            img {
              width: 1.7rem;
            }
          }
        }
      }
      &--description {
        font-size: 1.6rem;
        font-family: $font-primary;
        color: $color-black;
        margin-bottom: 0;
        line-height: 2.2rem;
        @include respond(phone-large) {
          font-size: 2.2rem;
          line-height: 3.3rem;
        }
        p, h1, h2, h3, h4, h5, h6, a, li {
          font-size: inherit;
          line-height: inherit;
          margin-bottom: 0.8rem;
        }
        hr {
          display: block;
          margin-bottom: 0.8rem;
        }
        ul, ol {
          padding-left: 2.5rem;
        }
        a {
          color: $color-links;
          cursor: pointer;
        }
      }
      &--reply {
          margin: 2rem 0rem;
          width: max-content;
          display: block;
          max-width: 80%;
          margin-left: auto;
          background-color: #eeeeee;
          border-radius: 2rem;
          padding: 0.8rem 1.5rem;
      }
      &--ai-meesage {
        font-style: italic;
        font-size: 1.6rem;
        font-family: $font-primary-medium;
        line-height: normal;
        margin: 1rem 0 0;
        color: $color-links;
        @include respond(phone-large) {
          font-size: 2.2rem;
        }
      }
    }
    .ant-row {
      row-gap: 1.2rem !important;
    }
    .select-user-card-title {
      margin-top: 1.8rem;
      font-size: 1.8rem;
      font-family: $font-primary-bold;
      line-height: normal;
      margin-bottom: 1rem;
      color: $color-black;
      @include respond(phone-large) {
        font-size: 2.4rem;
      }
    }
    .select-user-card {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      width: 100%;
      background-color: #eeeeee;
      padding: 1rem 1.3rem;
      border-radius: 1rem;
      @include respond(phone-large) {
        gap: 1.3rem;
        padding: 1.5rem 1.8rem;
      }
      &__field {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        p {
          font-size: 1.6rem;
          font-family: $font-primary;
          line-height: normal;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #4a4949;
          max-width: calc(100% - 3rem);
          span {
            font-family: $font-primary-medium;
            color: $color-black;
          }
          .details {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* number of lines to show */
                    line-clamp: 1; 
            -webkit-box-orient: vertical;
            color: inherit;
            font-family: inherit;
          }
        }
        .icon {
          width: 1.6rem;
          height: auto;
        }

        .copy-btn {
          border: none;
          outline: none;
          border-radius: 0.5rem;
          width: 2rem;
          height: 2rem;
          background-color: #8080803d;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-left: 0.3rem;
          position: relative;
          img {
            width: 1rem;
            height: auto;
          }
          .copied {
            position: absolute;
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            bottom: 0;
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            z-index: 1;
            background-color: $color-white;
            right: -6rem;
            p {
              font-size: 1rem;
              font-family: $font-primary;
              margin-bottom: 0;
              line-height: normal;
            }
          }
        }

        @include respond(phone-large) {
          gap: 1rem;
          p {
            font-size: 2.2rem;
            max-width: calc(100% - 5rem);
          }
          .icon {
            width: 2.7rem !important;
          }
          .telephone-icon {
            width: 2.6rem !important;
          }
          .copy-btn {
            width: 3.5rem;
            height: 3.5rem;
            img {
              width: 1.8rem;
            }
            .copied {
              right: -9rem;
              bottom: 0.4rem;
              z-index: 22;
              p {
                font-size: 1.8rem;
              }
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 0.4rem;
      height: 0.4rem;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 0.8rem;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 0.8rem;
    }
  }
  &__footer {
    width: calc(100% - 8rem);
    padding: 1.8rem 2.5rem;
    background-color: transparent;
    background-color: $color-white;
    width: 100%;
    border-end-start-radius: 2rem;
    border-end-end-radius: 2rem;
    &--comment {
      background-color: #eeeeee;
      padding: 0 1.4rem;
      border-radius: 1rem;
      display: flex;
      align-items: center;
      margin: 0 auto;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 100%;
        object-fit: fill;
        @include respond(phone-large) {
          width: 4.5rem;
          height: 4.5rem;
        }
      }
      textarea {
        padding: 0.8rem 1.5rem;
        margin: 0.5rem 0;
        border: none;
        font-size: 1.6rem;
        font-family: $font-primary;
        box-shadow: none;
        outline: none;
        line-height: 2.2rem;
        color: $color-black;
        background-color: transparent;
        resize: none;
        width: 100%;
        @include respond(phone-large) {
          font-size: 2.2rem;
          line-height: 3.3rem;
        }
        &::placeholder {
          color: #868686;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .buttons {
        display: flex;
        align-items: center;
        .disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .ant-btn {
          width: 5rem;
          background-color: $color-primary;
          border: none;
          outline: none;
          height: 3rem;
          color: $color-white;
          border-radius: 100px !important;
          padding: 0 !important;
          span {
            line-height: normal;
          }
          .anticon {
            .anticon-spin {
              font-size: 1.5rem !important;
              color: $color-primary;
            }
          }
          &:hover,
          &:focus {
            background-color: $color-primary;
            color: $color-white;
          }
          .icon {
            font-size: 1.5rem;
            display: block;
            color: $color-white;
          }
          @include respond(phone-large) {
            height: 4rem;
            width: 7rem;
            .anticon {
              .anticon-spin {
                font-size: 2.2rem !important;
              }
            }
            .icon {
              font-size: 2rem;
            }
          }
        }
      }
    }
  }
}
</style>
